module.exports = __webpack_public_path__ + "static/media/_MIC2612.thumbnail.78596d98.png";